import React, { useEffect, useRef, useState } from "react"
import { useLocation, useHistory } from "react-router"
import "./PatientDiagnosis.scss"
import SummaryView from "../../components/SummaryView/index"
import FollowUpVisit from "../../components/FollowUpVisit/index"
import ClinicalSummaryView from "../../components/ClinicalSummaryTab/ClinicalSummaryView"
import Toast from "../../components/Toast"
import { useSelector } from "react-redux"
import VitalsView from "../../components/VitalsView/VitalView"
import InitialExaminationView from "../../components/InitialExaminationView"
import StagingDiagnosis from "../../components/StagingDiagnosis/StagingDiagnosis"
import FlowSheetView from "../../components/FlowSheet"
import HistoryView from "../../components/HistoryView"
import ConsultantNotesView from "../../components/ConsultantNotesView"
import {
  addVital,
  raiseRmoApprovalRequest,
} from "../../core/services/api/patientDiagnosisService"
import { MocUserRole } from "../../core/services/models/Enums"
import RecordView from "../../components/VoiceRecorder"
import Drawingpad from "../../components/DrawingPad"
import Forms from "../../components/PatientDiagnosisDrawer/components/forms/Forms"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons"
import PatientDetailsPrintHeader from "components/CommonPrintComponent/PatientDetailsPrintHeader"
import fileUtils from "fileUtils"
import NewVitalsArray from "components/VitalsView/NewVitalsArray"
import Print from "components/Print/Print"

const PatientDiagnosis: React.FunctionComponent<any> = ({
  patientInfo,
  recordDetails,
  appointmentDetails,
  isStaffTypeView,
  isReadOnly,
  staffType,
  smartSummaryData,
  staffDetails,
  fetchSmartSummary
}) => {
  const [memoTabSection, updateMemoTabSection] = useState<string[]>([])
  const [selectedTab, setSelectedTab] = useState<string>("Smart Summary")
  const [selectedSubTab, setSelectedSubTab] = useState<string>("Vitals")
  const [selectedSubMemoTab, setSelectedSubMemoTab] = useState<string>("Add Instruction")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [displayToast, toggleDisplayToast] = useState<any>(false)
  const [drawingData, setDrawingData] = useState<any>([])
  const [resVitalData, setResVitalData] = useState<any>({})
  const [resCaseSummaryData, setResCaseSummaryData] = useState<any>({})
  const [resFollowUpData, setResFollowUpData] = useState<any>({})
  const [resConsultantNoteData, setResConsultantNoteData] = useState<any>({})
  const [resInitialExaminationData, setResInitialExaminationData] =
    useState<any>({})

  // temporary State
  const [isVitalData, setIsVitalData] = useState<boolean>(false)
  const [isSummaryData, setIsCaseSummaryData] = useState<boolean>(false)
  const [isConsultantNoteData, setIsConsultantNoteData] = useState<boolean>(false)
  const [isFollowUpData, setIsFollowUpData] = useState<boolean>(false)
  const [isInitialExaminationData, setIsInitialExaminationData] =
    useState<boolean>(false)
  const [raiseRequest, setRaiseRequest] = useState<boolean>(false)

  const [VitalsPayload, setVitalsPayload] = useState<any>({
    VitalsData: {
      Height: "",
      Weight: "",
      BSA: "0",
      BMI: "0",
      Temperature: "",
      BP: "",
      Pulse: "",
      SPO2: "",
      Haemoglobin: "",
      "Total WBC Count": "",
      "Platelets Count": "",
      "Absolute Neutrophil Count (ANC)": "",
      "Serum Creatinine": "",
      "eGFR- Creat Clearance": "",
      "Total Bilirubin": "",
      "SGOT (AST)": "",
      "ALT (SGPT)": "",
      Albumin: "",
      "Total Protein": "",
      "S.Calcium": "",
      "HGT-mg/dl": "",
      "Serum Bilirubin Direct": "",
    },
    VitalsBp: { "BP Systolic": "", "BP Diastolic": "" },
    errors: { errors: {}, bold: {}, color: {} },
  })
  const [beyondRange, setBeyondRange] = useState<boolean>(false)
  const [beyondLimit, setBeyondLimit] = useState<boolean>(false)
  const [mandatoryFields, setMandatoryFields] = useState<boolean>(false)
  const [allDetails, setAllDetails] = useState<boolean>(false)
  const [audioSaved, setAudioSaved] = useState<boolean>(false)
  const [drawingSaved, setDrawingSaved] = useState<boolean>(false)
  const [recordings, setRecordings] = useState([0])
  const [drawings, setDrawings] = useState([0])
  const [shows, setShows] = useState<boolean>(false)
  const [formSelected, setFormSelected] = useState<string>()
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const [isFailure, setIsFailure] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [heightValue, setHeightValue] = useState<any>("")

  const history = useHistory()
  const componentRef = useRef(null)
  const location = useLocation()
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const recordId = recordDetails?.id
  const patientId = appointmentDetails?.patientId
  const vitalsReferenceRange: any = {
    Height: "140-205",
    Weight: "0-130",
    BSA: "0.17-2.7",
    BMI: "0.5-30.9",
    Temperature: "97-99",
    "BP Systolic": "90-140",
    "BP Diastolic": "60-90",
    Pulse: "60-100",
    SPO2: "92-100",
    Haemoglobin: "12-16",
    "Total WBC Count": "4000-11000",
    "Platelets Count": "150-400",
    "Absolute Neutrophil Count (ANC)": "1500-6000",
    "Total Bilirubin": "0.1-1.2",
    "Serum Bilirubin Direct": "0.1-0.4",
    "Serum Bilirubin Indirect": "0.2-0.8",
    "SGOT (AST)": "4-44",
    "ALT (SGPT)": "4-44",
    "Total Protein": "6.7-8.3",
    Albumin: "3.8-5",
    Globulin: "2.9-3.3",
    "AG Ratio": "1.3-2.5",
    "Alkaline Phosphatase": "33-111",
    GGT: "16-73",
    "Serum Creatinine": "0.6-1.10",
    BUN: "8-23",
    Urea: "15-40",
    "Uric Acid": "3-5.5",
    Sodium: "136-149",
    Potassium: "3.8-5.0",
    Chloride: "96-108",
    "S.Calcium": "8.4-10.2",
    LDH: "106-211",
    "eGFR- Creat Clearance": "60-130",
    "HGT-mg/dl": "80-140",
  }

  const tabSection = [
    "Smart Summary",
    "Current Visit",
    "Clinical Summary",
    "Consultant Notes",
    "Instruction",
  ]

  const subTabSection: string[] = [
    "Vitals",
    "Initial Examination",
    "History",
    "Staging & Diagnosis",
    "Flowsheet",
  ]

  const handleRaiseRequest = () => {
    let queryStr = "The following vitals exceed the range: "
    Object.keys(VitalsPayload?.errors?.color).forEach((ele: any, index: any) => {
      if (index === Object.keys(VitalsPayload?.errors?.color)?.length - 1) {
        queryStr += `${ele}:${ele === "BP Systolic" ? VitalsPayload?.VitalsBp["BP Systolic"] : ele === "BP Diastolic" ? VitalsPayload?.VitalsBp["BP Diastolic"] : VitalsPayload?.VitalsData[ele]}(${ele === "BP Systolic" ? vitalsReferenceRange["BP Systolic"] : ele === "BP Diastolic" ? vitalsReferenceRange["BP Diastolic"] : vitalsReferenceRange[ele]}).`;
      } else {
        queryStr += `${ele}:${ele === "BP Systolic" ? VitalsPayload?.VitalsBp["BP Systolic"] : ele === "BP Diastolic" ? VitalsPayload?.VitalsBp["BP Diastolic"] : VitalsPayload?.VitalsData[ele]}(${ele === "BP Systolic" ? vitalsReferenceRange["BP Systolic"] : ele === "BP Diastolic" ? vitalsReferenceRange["BP Diastolic"] : vitalsReferenceRange[ele]}), `;
      }

    })
    raiseRmoApprovalRequest({
      rmoId: userDetail?.id,
      appointmentDate: appointmentDetails?.scheduleDate,
      vitalCaptureDate: appointmentDetails?.scheduleDate,
      consultantId: consultantId,
      patientId: patientId,
      recordId: recordId,
      centerId: centerId,
      // rmoName: appointmentDetails?.consultantName,
      approvalFor: queryStr,
      reason: "",
    })
      .then((data: any) => {
        setBeyondRange(false)
        //To save vitals after raise request
        handleVitalsRaiseRequest()
      })
      .catch((err: any) => {
        console.log(err)
      })
  }

  function MemoView(isReadOnly: any): React.ReactNode {
    return (
      <div className="visit-container">
        {
          isLoading && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "50%",
              }}
            >
              <div
                style={{ width: "3rem", height: "3rem" }}
                className="spinner-border text-primary"
              ></div>
            </div>
          )
        }
        <div className="vertical-tab-container">
          {memoTabSection.map((tabname: any) => (
            <div
              className={`vertical-tab ${selectedSubMemoTab === tabname ? "active" : ""
                }`}
              onClick={() => setSelectedSubMemoTab(tabname)}>
              {tabname}
            </div>
          ))}
        </div>
        <div className="visit-content">
          <div className="memo-view">
            {selectedSubMemoTab === "Saved Instruction" ? (
              <>
                {
                  userRole === MocUserRole?.RMO && (
                    <div className="d-flex m-5">
                      <div className="add-new-button"
                      >
                        <div onClick={() => handleForms()}>Thank you Note</div>

                      </div>


                      <div className="add-new-button" onClick={() => handleFormeds()}>Referral Note</div>
                    </div>
                  )
                }

                {
                  shows ? <Forms
                    patientInfo={patientInfo}
                    show={shows}
                    setShow={setShows}
                    appointmentId={appointmentId}
                    appointment={appointmentDetails}
                    chosenForm={formSelected}
                    staffInfo={staffDetails}
                  />
                    :
                    <></>
                }

                <div ref={componentRef}>
                  <div className="print-only">
                    <PatientDetailsPrintHeader
                      patientData={{ patientInfo: patientInfo, vitalsData: null }}
                      smartSummaryData={smartSummaryData}
                      appointmentDate={appointmentDetails?.scheduleDate}
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <span style={{ textDecoration: "underline", fontWeight: "bolder" }}>Saved Drawings</span>
                    <span
                      className="print-only-button cursor-pointer"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Print
                        componentRef={componentRef}
                      />
                    </span>
                  </div>
                  <div>
                    {drawingData?.writings?.map((data: any) => {
                      return (
                        <div style={{ border: "1px solid #d3d3d3", padding: "5px", backgroundColor: "#fff", marginBottom: "10px" }}>
                          <img style={{ width: "100%" }} src={data.blobUrl} alt="" />
                        </div>
                      )
                    })}
                  </div>
                </div>

                <div style={{ textDecoration: "underline", fontWeight: "bolder", margin: "15px 0" }}>Saved Audios</div>
                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                  {drawingData?.audios?.map((data: any) => {
                    return <div>
                      <p style={{ textAlign: "center", width: "300px" }}>
                        <a
                          onClick={() => fileUtils.downloadFile(data)}
                        >
                          <FontAwesomeIcon
                            className="download-icon"
                            icon={faArrowDown}
                          />
                          &nbsp;{data?.name}
                        </a>
                      </p>
                      <audio src={data?.blobUrl} controls loop />
                    </div>

                  })}
                </div>
              </>
            ) : selectedSubMemoTab === "Add Instruction" ? (
              <>
                <div className="d-flex m-5">
                  <div className="add-new-button"
                  >
                    <div onClick={() => handleForms()}>Thank you Note</div>

                  </div>


                  <div className="add-new-button" onClick={() => handleFormeds()}>Referral Note</div>
                </div>

                {
                  shows ? <Forms
                    patientInfo={patientInfo}
                    show={shows}
                    setShow={setShows}
                    appointmentId={appointmentId}
                    appointment={appointmentDetails}
                    staffInfo={staffDetails}
                  />
                    :
                    <></>
                }
                <div>
                  <h3 className="mb-4">
                    Press the Start to recording
                  </h3>
                  <div className="d-flex justify-content-around align-items-center">
                    <div style={{ minWidth: "150px" }}>
                      <label>File name: </label>
                    </div>
                    <div style={{ minWidth: "150px" }}>
                      <label>Status: </label>
                    </div>
                    <div style={{ minWidth: "150px" }}>
                      <label>Audio: </label>
                    </div>
                    <div style={{ minWidth: "150px", paddingLeft: "20px" }}>
                      <label>Duration: </label>
                    </div>
                  </div>
                  {
                    recordings.map((ele: any) => {
                      return (
                        <RecordView
                          patienntId={patientId}
                          recordId={recordId}
                          setAudioSaved={setAudioSaved}
                          drawingData={drawingData}
                          setDrawingData={setDrawingData}
                          setIsLoading={setIsLoading}
                          number={ele}
                          isReadOnly={isReadOnly}
                        />
                      )
                    })
                  }
                </div>
                {
                  !isReadOnly && (
                    <div
                      className="add-new-button mb-4"
                      onClick={() => {
                        let temp = [...recordings]
                        temp.push(temp[recordings.length - 1] + 1)
                        setRecordings(temp)
                      }}
                    >
                      Add New
                    </div>
                  )
                }

                <div className="writing-pad">
                  <h3 className="mb-4 mt-4">
                    Start drawing
                  </h3>
                  {
                    drawings.map((ele: any) => {
                      return (
                        <Drawingpad
                          recordId={recordId}
                          setDrawingSaved={setDrawingSaved}
                          drawingData={drawingData}
                          setDrawingData={setDrawingData}
                          setIsLoading={setIsLoading}
                          isReadOnly={isReadOnly}
                        />
                      )
                    })
                  }
                </div>
                {
                  !isReadOnly && (
                    <div
                      className="add-new-button"
                      onClick={() => {
                        let temp = [...drawings]
                        temp.push(temp[drawings.length - 1] + 1)
                        setDrawings(temp)
                      }}
                    >
                      Add New
                    </div>
                  )
                }
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div >
    )
  }

  const getVitalsPayload = (vitalsObj: any) => {
    setVitalsPayload(vitalsObj)
  }

  const handleVitalsSave = () => {
    addVital(
      {
        ...VitalsPayload?.VitalsData,
        vitalCaptureDate: appointmentDetails?.scheduleDate,
        bpSystolic: VitalsPayload?.VitalsBp["BP Systolic"],
        bpDiastolic: VitalsPayload?.VitalsBp["BP Diastolic"],
      },
      { centerId, consultantId, patientId, appointmentId, recordId }
    )
      .then((data: any) => {
        setBeyondLimit(false)
        setResVitalData(data)
        setIsVitalData(true)
        setHeightFunc(data.height)
      })
      .catch((err: any) => {
        toggleDisplayToast({
          text: `${err?.response?.data?.message ? err?.response?.data?.message : "Something went wrong, Please try again later."}`,
          type: "error",
        })
        console.error(err)
      })
  }

  const handleVitalsRaiseRequest = () => {
    addVital(
      {
        ...VitalsPayload?.VitalsData,
        vitalCaptureDate: appointmentDetails?.scheduleDate,
        bpSystolic: VitalsPayload?.VitalsBp["BP Systolic"],
        bpDiastolic: VitalsPayload?.VitalsBp["BP Diastolic"],
      },
      { centerId, consultantId, patientId, appointmentId, recordId }
    )
      .then((data: any) => {
        setBeyondLimit(false)
        setResVitalData(data)
        setRaiseRequest(true)
        setHeightFunc(data.height)
      })
      .catch((err: any) => {
        console.log(err)
        toggleDisplayToast({
          text: `${err?.response?.data?.message ? err?.response?.data?.message : "Something went wrong, Please try again later."}`,
          type: "error",
        })
      })
  }

  function scroll() {
    const element = document.getElementById('patientDiagnosis');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const setHeightFunc = (value: any) => {
    setHeightValue(value)
  }

  function currentVisitView(): React.ReactNode {
    return (
      <div className="visit-container">
        <div className="vertical-tab-container">
          {subTabSection.map((tabname) => (
            <div
              className={`vertical-tab ${selectedSubTab === tabname ? "active" : ""
                }`}
              onClick={() => setSelectedSubTab(tabname)}>
              {tabname}
            </div>
          ))}
        </div>
        <div className="visit-content">
          {selectedSubTab === "Vitals" ? (
            <>
              <VitalsView
                resVitalData={resVitalData}
                setHeightFunc={setHeightFunc}
                patientDetail={patientInfo}
                setIsVitalData={setIsVitalData}
                setResVitalData={setResVitalData}
                setBeyondRange={setBeyondRange}
                setBeyondLimit={setBeyondLimit}
                setMandatoryFields={setMandatoryFields}
                setAllDetails={setAllDetails}
                getVitalsPayload={getVitalsPayload}
                recordDetails={recordDetails}
                appointmentDetails={appointmentDetails}
                isReadOnly={isReadOnly}
                scroll={scroll}
              />
              <NewVitalsArray
                patientDetail={patientInfo}
                recordDetails={recordDetails}
                appointmentDetails={appointmentDetails}
                isReadOnly={isReadOnly}
                userDetail={userDetail}
                heightValue={heightValue}
              />
            </>
          ) : selectedSubTab === "Initial Examination" ? (
            <InitialExaminationView
              setResInitialExaminationData={setResInitialExaminationData}
              setIsInitialExaminationData={setIsInitialExaminationData}
              recordDetails={recordDetails}
              appointmentDetails={appointmentDetails}
              isReadOnly={isReadOnly}
              scroll={scroll}
            />
          ) : selectedSubTab === "History" ? (
            <HistoryView
              setResCaseSummaryData={setResCaseSummaryData}
              patientDetail={patientInfo}
              setIsCaseSummaryData={setIsCaseSummaryData}
              recordDetails={recordDetails}
              appointmentDetails={appointmentDetails}
              isReadOnly={(userRole === MocUserRole.CONSULTANT || userRole === MocUserRole.RMO) ? false : isReadOnly}
              scrollToTop={scroll}
            />
          ) : selectedSubTab === "Staging & Diagnosis" ? (
            <StagingDiagnosis
              patientDetail={patientInfo}
              recordDetails={recordDetails}
              appointmentDetails={appointmentDetails}
              isReadOnly={(userRole === MocUserRole.CONSULTANT || userRole === MocUserRole.RMO) ? false : isReadOnly}
              scroll={scroll}
            />
          ) : selectedSubTab === "Consultant Notes" ? (
            <ConsultantNotesView
              setResConsultantNoteData={setResConsultantNoteData}
              setIsConsultantNoteData={setIsConsultantNoteData}
              recordDetails={recordDetails}
              appointmentDetails={appointmentDetails}
              patientDetail={patientInfo}
              isReadOnly={isReadOnly}
              smartSummaryData={smartSummaryData}
            />
          ) : selectedSubTab === "Flowsheet" ? (
            <FlowSheetView
              patientId={patientId}
              scroll={scroll}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }

  function handleForms() {
    setShows(true)
    setFormSelected("Thank you Note")
  }

  function handleFormeds() {
    setShows(true)
    setFormSelected("Referral Note")
  }

  useEffect(() => {
    if (userRole || appointmentDetails?.staffType) {
      if (
        userRole === MocUserRole.CONSULTANT ||
        (isStaffTypeView && staffType?.toLowerCase() === "consultant")
      ) {
        updateMemoTabSection([
          "Add Instruction",
          "Saved Instruction"
        ])
        setSelectedSubMemoTab("Add Instruction")
      } else {
        updateMemoTabSection(["Saved Instruction"])
        setSelectedSubMemoTab("Saved Instruction")
      }
    }
  }, [])

  useEffect(() => {
    if (appointmentId && recordDetails)
      setDrawingData(recordDetails)
  }, [appointmentId, recordDetails])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname])

  return (
    <div className="patient-diagnosis-container">
      {/* temp code for demo */}
      {isVitalData && resVitalData?.id ? (
        <Toast
          textMessage={` Vital Data added Successfully`}
          type="success"
          onCloseText={"Close"}
          onClickText={"Appointments"}
          onClose={() => setIsVitalData(false)}
          onClick={() => history.push("/calendar")}></Toast>
      ) : isSummaryData && resCaseSummaryData?.id ? (
        <Toast
          textMessage={`History Data added Successfully`}
          type="success"
          onCloseText={"Close"}
          onClickText={"Appointments"}
          onClose={() => setIsCaseSummaryData(false)}
          onClick={() => history.push("/calendar")}></Toast>
      ) : isInitialExaminationData && resInitialExaminationData?.id ? (
        <Toast
          textMessage={` Initial Examination Data added Successfully`}
          type="success"
          onCloseText={"Close"}
          onClickText={"Appointments"}
          onClose={() => setIsInitialExaminationData(false)}
          onClick={() => history.push("/calendar")}></Toast>
      ) : resConsultantNoteData?.id && isConsultantNoteData ? (
        <Toast
          textMessage={` Consultant Notes Data added Successfully`}
          type="success"
          onCloseText={"Close"}
          onClickText={"Appointments"}
          onClose={() => setIsConsultantNoteData(false)}
          onClick={() => history.push("/calendar")}></Toast>
      ) : resFollowUpData?.id && isFollowUpData ? (
        <Toast
          textMessage={` Consultant Notes Data added Successfully`}
          type="success"
          onCloseText={"Close"}
          onClickText={"Appointments"}
          onClose={() => setIsFollowUpData(false)}
          onClick={() => history.push("/calendar")}></Toast>
      ) : beyondRange ? (
        <Toast
          textMessage={`One or more fields exceed beyond range, Do you want to proceed further`}
          type="warning"
          onCloseText={"Close"}
          onClickText={"Raise Request"}
          onClose={() => {
            setBeyondRange(false)
          }}
          onClick={handleRaiseRequest}></Toast>
      ) : beyondLimit ? (
        <Toast
          textMessage={`One or more fields exceed beyond limit, Do you want to proceed further`}
          type="error"
          onCloseText={"Close"}
          onClickText={"Save Anyways"}
          onClose={() => {
            setBeyondLimit(false)
          }}
          onClick={handleVitalsSave}></Toast>
      ) : mandatoryFields ? (
        <Toast
          textMessage={`Please enter all mandatory details`}
          type="error"
          onCloseText={"Close"}
          onClose={() => {
            setMandatoryFields(false)
          }}></Toast>
      ) : allDetails ? (
        <Toast
          textMessage={`You have not entered all test details. Do you want to proceed further?`}
          type="warning"
          onCloseText={"Close"}
          onClickText={"Save Anyways"}
          onClose={() => {
            setAllDetails(false)
          }}
          onClick={() => {
            setAllDetails(false)
            handleVitalsSave()
          }}></Toast>
      ) : raiseRequest ? (
        <Toast
          textMessage={`Request Raised Successfully`}
          type="success"
          onCloseText={"Close"}
          onClickText={"Appointments"}
          onClose={() => setRaiseRequest(false)}
          onClick={() => history.push("/calendar")}></Toast>
      ) : audioSaved ? (
        <Toast
          textMessage={"Audio Saved Successfully"}
          type="success"
          onCloseText={"Close"}
          onClose={() => setAudioSaved(false)}
        ></Toast>
      ) : drawingSaved ? (
        <Toast
          textMessage={"Writing Saved Successfully"}
          type="success"
          onCloseText={"Close"}
          onClose={() => setDrawingSaved(false)}
        ></Toast>
      ) : isSuccess ? (
        <Toast
          textMessage={"Clinical Summary Downloaded Successfully"}
          type="success"
          onCloseText={"Close"}
          onClose={() => setIsSuccess(false)}
        ></Toast>
      ) : isFailure ? (
        <Toast
          textMessage={"Patient diagnosis is empty, failed to generate clinical summary"}
          type="error"
          onCloseText={"Close"}
          onClose={() => setIsFailure(false)}
        ></Toast>
      ) : displayToast ? (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => toggleDisplayToast(false)}
          onCloseText="Close"
          onClickText={null}
        />
      ) : null
      }
      <div className="patient-diagnosis">
        {
          loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "50%",
              }}
            >
              <div
                style={{ width: "3rem", height: "3rem" }}
                className="spinner-border text-primary"
              ></div>
            </div>
          ) : null
        }
        <div className="patient-smart-summary" >
          <div className="tab-wrapper">
            {tabSection.map((tabname: any, index: number) => (
              <div
                key={`tab-section-${index}`}
                className={`tab ${selectedTab === tabname ? "active" : ""}`}
                onClick={() => {
                  setSelectedTab(tabname)
                  if (tabname === "Smart Summary") {
                    fetchSmartSummary()
                  }
                }
                }>
                {tabname}
                {tabname === "Clinical Summary" && (
                  <img
                    className="eye-icon"
                    src={"../../assets/images/eyeIcon.svg"}
                    width={18}
                    height={20}
                    style={{ paddingLeft: '3px' }}
                    alt="eye"
                  />
                )}
              </div>
            ))}
          </div>
          <div className="content-wrapper">
            {selectedTab === "Smart Summary" ? (
              <>
                <SummaryView
                  patientDetail={patientInfo}
                  smartSummaryDetails={smartSummaryData}
                  scroll={scroll}
                />
              </>
            ) : selectedTab === "Current Visit" ? (
              currentVisitView()
            ) : selectedTab === "Instruction" ? (
              MemoView(isReadOnly)
            ) : selectedTab === "Consultant Notes" ? (
              <FollowUpVisit
                isEditable={true}
                setResFollowUpData={setResFollowUpData}
                setIsFollowUpData={setIsFollowUpData}
                recordDetails={recordDetails}
                appointmentDetails={appointmentDetails}
                patientDetail={patientInfo}
                isReadOnly={isReadOnly}
                smartSummaryData={smartSummaryData}
                scroll={scroll}
              />
            ) : (
              <ClinicalSummaryView
                appointmentDetails={appointmentDetails}
                patient={patientInfo?.mocId}
                scroll={scroll}
              />
            )}
          </div>
        </div>
      </div>
    </div >
  )
}

export default PatientDiagnosis
